<template>
  <div class="admin-page">
    <div class="admin-toolbar">
      <div class="admin-toolbar__actions">
        <el-select v-model="scope" style="width: 140px" @change="fetchList">
          <el-option label="测评" value="exam" />
          <el-option label="编辑推荐" value="blog" />
          <el-option label="课程" value="course" />
        </el-select>
        <el-button type="primary" @click="openCreate">新增标签</el-button>
      </div>
    </div>

    <p class="page-hint">
      一张字典按 scope 区分测评 / 编辑推荐 / 课程。C 端列表点标签筛选；编辑页只能从字典多选，不能自由创建。
      测评 JSON 里的 <code>question_tag</code> 是计分维度，与这里无关，不要改。
    </p>

    <el-table :data="items" v-loading="loading" style="width: 100%">
      <el-table-column prop="tagId" label="ID" width="80" />
      <el-table-column prop="name" label="名称" min-width="140" />
      <el-table-column prop="scope" label="范围" width="100">
        <template #default="s">{{ scopeLabel(s.row.scope) }}</template>
      </el-table-column>
      <el-table-column label="推荐" width="88">
        <template #default="s">
          <el-tag :type="s.row.isRecommended ? 'success' : 'info'" size="small">
            {{ s.row.isRecommended ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortOrder" label="排序" width="80" />
      <el-table-column label="启用" width="80">
        <template #default="s">
          <el-tag :type="s.row.enabled ? 'success' : 'info'" size="small">
            {{ s.row.enabled ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="颜色" width="90">
        <template #default="s">
          <span v-if="s.row.color" class="color-dot" :style="{ background: s.row.color }" />
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="s">
          <el-button size="small" type="primary" @click="openEdit(s.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="dialogVisible" :title="editForm.tagId ? '编辑标签' : '新增标签'" width="480px" destroy-on-close>
      <el-form label-width="96px">
        <el-form-item label="范围" required>
          <el-select v-model="editForm.scope" :disabled="!!editForm.tagId" style="width: 100%">
            <el-option label="测评" value="exam" />
            <el-option label="编辑推荐" value="blog" />
            <el-option label="课程" value="course" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" required>
          <el-input v-model="editForm.name" maxlength="32" show-word-limit />
        </el-form-item>
        <el-form-item label="系统推荐">
          <el-switch v-model="editForm.isRecommended" :active-value="1" :inactive-value="0" />
          <span class="field-hint">推荐标签会出现在 /exames 等列表默认筛选条</span>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="editForm.sortOrder" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="editForm.enabled" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="颜色">
          <el-input v-model="editForm.color" placeholder="#409EFF，可空" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem('jwt_token') || ''}`,
    'Content-Type': 'application/json'
  }
}

export default {
  name: 'AdminContentTagManagement',
  data() {
    return {
      loading: false,
      saving: false,
      scope: 'exam',
      items: [],
      dialogVisible: false,
      editForm: emptyForm('exam')
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    scopeLabel(scope) {
      return { exam: '测评', blog: '编辑推荐', course: '课程' }[scope] || scope
    },
    async fetchList() {
      this.loading = true
      try {
        const response = await axios.post(
          '/api/v1/admin/content/tag/list',
          { scope: this.scope, includeDisabled: 1 },
          { headers: authHeaders() }
        )
        if (response.data.code === 200) {
          this.items = response.data.data?.tags || []
        } else {
          ElMessage.error(response.data.message || '获取标签失败')
        }
      } catch {
        ElMessage.error('获取标签失败')
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.editForm = emptyForm(this.scope)
      this.dialogVisible = true
    },
    openEdit(row) {
      this.editForm = {
        tagId: row.tagId,
        name: row.name,
        scope: row.scope,
        isRecommended: Number(row.isRecommended) === 1 ? 1 : 0,
        sortOrder: Number(row.sortOrder) || 0,
        enabled: Number(row.enabled) === 1 ? 1 : 0,
        color: row.color || ''
      }
      this.dialogVisible = true
    },
    async save() {
      const name = (this.editForm.name || '').trim()
      if (!name) {
        ElMessage.warning('请填写名称')
        return
      }
      this.saving = true
      try {
        const url = this.editForm.tagId
          ? '/api/v1/admin/content/tag/update'
          : '/api/v1/admin/content/tag/add'
        const body = this.editForm.tagId
          ? {
              tagId: this.editForm.tagId,
              name,
              isRecommended: this.editForm.isRecommended,
              sortOrder: this.editForm.sortOrder,
              enabled: this.editForm.enabled,
              color: this.editForm.color || ''
            }
          : {
              name,
              scope: this.editForm.scope,
              isRecommended: this.editForm.isRecommended,
              sortOrder: this.editForm.sortOrder,
              enabled: this.editForm.enabled,
              color: this.editForm.color || ''
            }
        const response = await axios.post(url, body, { headers: authHeaders() })
        if (response.data.code === 200) {
          ElMessage.success('已保存')
          this.dialogVisible = false
          this.fetchList()
        } else {
          ElMessage.error(response.data.message || '保存失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '保存失败')
      } finally {
        this.saving = false
      }
    },
    async remove(row) {
      try {
        await ElMessageBox.confirm(`删除标签「${row.name}」会同时解除绑定，确定吗？`, '删除确认', {
          type: 'warning'
        })
      } catch {
        return
      }
      try {
        const response = await axios.post(
          '/api/v1/admin/content/tag/delete',
          { tagId: row.tagId },
          { headers: authHeaders() }
        )
        if (response.data.code === 200) {
          ElMessage.success('已删除')
          this.fetchList()
        } else {
          ElMessage.error(response.data.message || '删除失败')
        }
      } catch {
        ElMessage.error('删除失败')
      }
    }
  }
}

function emptyForm(scope) {
  return {
    tagId: 0,
    name: '',
    scope: scope || 'exam',
    isRecommended: 1,
    sortOrder: 0,
    enabled: 1,
    color: ''
  }
}
</script>

<style scoped>
.page-hint {
  color: #606266;
  font-size: 13px;
  margin: 0 0 16px;
  line-height: 1.6;
}

.field-hint {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}

.color-dot {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #dcdfe6;
}
</style>
